/**
 * Shared public SSR route config: used by entry-server (SSR) and PublicHydrationRoot (client hydration).
 * Keeps server and client tree identical to avoid hydration mismatch.
 */
import React from 'react'
import LandingPage from '../pages/LandingPage'
import FaqPage from '../pages/FaqPage'

function c<T extends React.ComponentType<any>>(C: T): T {
  const X = (C as any)?.default ?? C
  return (typeof X === 'function' ? X : C) as T
}

export const PUBLIC_SSR_PATHNAMES = ['/', '/faq'] as const

export const PUBLIC_ROUTES: Record<string, React.ComponentType<any>> = {
  '/': c(LandingPage),
  '/faq': c(FaqPage)
}

export function getPublicPageComponent(pathname: string): React.ComponentType<any> {
  const route = pathname === '' ? '/' : pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname
  return PUBLIC_ROUTES[route] ?? c(LandingPage)
}

export function isPublicSSRPath(pathname: string): boolean {
  const normalized = pathname === '' ? '/' : pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname
  return (PUBLIC_SSR_PATHNAMES as readonly string[]).includes(normalized)
}
